// Default state
export default {
  hydrated: false,
  hydratingError: null,
  latency: [],
  currentUser: {},
  bookmarks: [],
  sidebars: {
    nav: false,
    info: false
  },
  queue: []
};
